import axios from "axios"
import { ADDRESS_ENDPOINT } from "../../../../../../utility/SourceAPI"


export const fetchAddresses = async () => {
    const response = await axios.get(ADDRESS_ENDPOINT)
    return response.data
}

export const createAddress = async (addressData) => {
    const response = await axios.post(ADDRESS_ENDPOINT, addressData)
    return response.data
}

export const updateAddress = async (addressId, addressData) => {
    const response = await axios.put(`${ADDRESS_ENDPOINT}id/${addressId}`, addressData)
    return response.data
}
